module.exports = __webpack_public_path__ + "static/3b15daf5-d7fb-4099-93b9-db20fd26c2fe-e415dae6a6f08172eb978b1a8f590302.woff";